import { isUndefined } from 'lodash';
import { useCallback } from 'react';

import {
   Link,
   StandardSpinner,
   Tooltip,
   useHistoryPushWithBackAction,
   VisitPreviewIcon,
} from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';
import { visitPaths } from '~libs.desktop.shared.paths';

import { useVisitStatusGlobalState } from '../../../../shared/VisitStatusResolver/VisitStatusResolver.hooks';
import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../translations';

type RelatedVisitCellProps = {
   readonly visitId: number;
   readonly patientId: number;
};

export const RelatedVisitCell = (props: RelatedVisitCellProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(true);
   const medicalDataAvailable = protectFeature('searchingMedicalData');
   const { getStatus } = useVisitStatusGlobalState();
   const status = getStatus(props.visitId);
   const visitClosed = status === 'FINISHED_APPROVED';
   const disabled = !medicalDataAvailable || !visitClosed;

   const handleClick = useCallback(() => {
      push(
         visitPaths.getVisitHistoryPath({
            params: {
               patientId: props.patientId,
            },
            searchParams: {
               visitId: props.visitId,
            },
         }),
         {
            label:
               patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.table.columns.actions
                  .relatedVisit.backActionLabel,
         }
      );
   }, [push, props.patientId, props.visitId]);

   if (isUndefined(status)) {
      return <StandardSpinner />;
   }

   return (
      <Tooltip
         content={
            medicalDataAvailable
               ? patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.table.columns.actions
                    .relatedVisit.tooltip.visitNotFinished
               : patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.table.columns.actions
                    .relatedVisit.tooltip.noAccessToMedicalData
         }
         testId={'relatedVisit'}
         disabled={!disabled}
      >
         <Link
            testId={'relatedVisit'}
            label={
               patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.table.columns.actions
                  .relatedVisit.label
            }
            icon={<VisitPreviewIcon />}
            disabled={disabled}
            onClick={handleClick}
         />
      </Tooltip>
   );
};
